var _defs, _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(100%, 100%, 100%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(81.17981%, 42.349243%, 18.429565%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.192122, 62.265437)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.90625 -36.96875 L 3.59375 -41.5 C 3.675781 -41.789062 3.800781 -42.195312 3.96875 -42.71875 C 4.132812 -43.25 4.632812 -44.164062 5.46875 -45.46875 C 6.3125 -46.769531 7.300781 -47.921875 8.4375 -48.921875 C 9.570312 -49.929688 11.226562 -50.84375 13.40625 -51.65625 C 15.59375 -52.476562 18.050781 -52.890625 20.78125 -52.890625 C 25.726562 -52.890625 29.804688 -51.472656 33.015625 -48.640625 C 36.234375 -45.804688 37.84375 -42.1875 37.84375 -37.78125 C 37.84375 -33.664062 36.3125 -30.410156 33.25 -28.015625 C 37.65625 -25.328125 39.859375 -21.363281 39.859375 -16.125 C 39.859375 -11.164062 38.039062 -7.082031 34.40625 -3.875 C 30.78125 -0.664062 26.175781 0.9375 20.59375 0.9375 C 17.613281 0.9375 14.90625 0.5 12.46875 -0.375 C 10.03125 -1.257812 8.128906 -2.320312 6.765625 -3.5625 C 5.398438 -4.800781 4.265625 -6.046875 3.359375 -7.296875 C 2.460938 -8.554688 1.847656 -9.628906 1.515625 -10.515625 L 1.078125 -11.84375 L 12.03125 -17.1875 C 12.03125 -16.976562 12.0625 -16.695312 12.125 -16.34375 C 12.1875 -15.988281 12.40625 -15.347656 12.78125 -14.421875 C 13.15625 -13.492188 13.613281 -12.679688 14.15625 -11.984375 C 14.707031 -11.296875 15.539062 -10.664062 16.65625 -10.09375 C 17.769531 -9.53125 19.0625 -9.25 20.53125 -9.25 C 22.75 -9.25 24.550781 -9.859375 25.9375 -11.078125 C 27.320312 -12.296875 28.015625 -13.976562 28.015625 -16.125 C 28.015625 -18.34375 27.289062 -20.164062 25.84375 -21.59375 C 24.394531 -23.019531 22.625 -23.734375 20.53125 -23.734375 L 18.265625 -23.359375 L 18.265625 -31.109375 L 20.84375 -31.109375 C 22.476562 -31.109375 23.925781 -31.738281 25.1875 -33 C 26.445312 -34.257812 27.078125 -35.8125 27.078125 -37.65625 C 27.078125 -39.289062 26.4375 -40.65625 25.15625 -41.75 C 23.875 -42.84375 22.375 -43.390625 20.65625 -43.390625 C 19.4375 -43.390625 18.332031 -43.164062 17.34375 -42.71875 C 16.363281 -42.28125 15.609375 -41.742188 15.078125 -41.109375 C 14.554688 -40.484375 14.113281 -39.851562 13.75 -39.21875 C 13.394531 -38.59375 13.175781 -38.070312 13.09375 -37.65625 Z M 12.90625 -36.96875 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.955afddeed3d7e4cd8e40d5164beddee.svg";
export { ForwardRef as ReactComponent };